module.exports = __webpack_public_path__ + "assets/img/detail1.6d1afe17.png";